export interface LoginData {
  email: string;
  password: string;
}

export interface RegisterData {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
}

export interface Auth {
  accessToken: string;
  twoFactorEnabled?: boolean;
  twoFactorRequired?: boolean;
  message?: string;
}

export const emailRules = [
  (value: string) => {
    if (value) return true;

    return 'E-mail is required.';
  },
  (value: string) => {
    if (/.+@.+\..+/.test(value)) return true;

    return 'E-mail must be valid.';
  },
];

export const passwordRules = [
  (value: string) => {
    if (value) return true;

    return 'Password is required.';
  },
];

export const digitRules = [
  (value: string) => {
    if (value) return true;

    return '6 Digit code is required.';
  },
  (value: string) => {
    if (value.length === 6) return true;

    return '6 Digit code should consist of 6 digits.';
  },
  (value: string) => {
    if (value.match(/[0-9]{6}/g) !== null) return true;

    return '6 Digit code should consist of 6 numbers, not characters.';
  },
];

export const firstnameRules = [
  (value: string) => {
    if (value) return true;

    return 'First name is required.';
  },
];

export const lastnameRules = [
  (value: string) => {
    if (value) return true;

    return 'Last name is required.';
  },
];
